import request from '@/utils/request'
// 产品下拉
export function product_select (data) {
    return request({
        url: '/product/select',
        method: "get",
        params: data,
    })
}
// 批次下拉
export function batch_select (data) {
    return request({
        url: '/batch/select',
        method: "get",
        params: data,
    })
}
// 行业下拉
export function other_industry_list (data) {
    return request({
        url: '/other/industry_list',
        method: "get",
        params: data,
    })
}
// 获取产品分类下拉
export function product_type_select (data) {
    return request({
        url: '/product/type/select',
        method: "get",
        params: data,
    })
}
// 产品属性下拉
export function product_attribute_select (data) {
    return request({
        url: '/product/attribute/select',
        method: "get",
        params: data,
    })
}
// 代理商下拉
export function agent_select (data) {
    return request({
        url: '/agent/select',
        method: "get",
        params: data,
    })
}
// 代理商等级下拉
export function agent_level_select (data) {
    return request({
        url: '/agent/level/select',
        method: "get",
        params: data,
    })
}
// 门店类型下拉
export function store_type_select (data) {
    return request({
        url: '/store/type/select',
        method: "get",
        params: data,
    })
}
// 外箱码生成记录下拉（批次下拉）
export function packing_count_select (data) {
    return request({
        url: '/packing/count/select',
        method: "get",
        params: data,
    })
}
// 仓库下拉
export function warehouse_select (data) {
    return request({
        url: '/warehouse/select',
        method: "get",
        params: data,
    })
}
// 门店下拉
export function store_select (data) {
    return request({
        url: '/store/select',
        method: "get",
        params: data,
    })
}
// 物流公司下拉
export function incoming_select (data) {
    return request({
        url: '/incoming/select',
        method: "post",
        data
    })
}
// 角色下拉
export function account_roles_select (data) {
    return request({
        url: '/account/roles/select',
        method: "get",
        params: data,
    })
}
// DIY模板的页面管理- diy下拉页
export function diy_manage_select (data) {
    return request({
        url: '/template/diy/manage_select',
        method: "get",
        params: data,
    })
}